import type { PaginationParams } from "@/react/types";

import { absolutePath } from "./absolutePath";

export const marketingEmailTemplates = {
  index: ({ params = {} }: { params?: PaginationParams } = {}) =>
    absolutePath("marketing_email_templates", params),
  item: ({ id }: { id: number }) =>
    absolutePath(`marketing_email_templates/${id}`),
  exists: () => absolutePath("marketing_email_templates/exists"),
  disableSaveEmailTemplatePrompt: () =>
    absolutePath(
      "marketing_email_templates/disable_save_email_template_prompt",
    ),
} as const;
